import React from 'react';
export const TestMemberContainer = React.memo(() => {
    return (React.createElement("div", null,
        React.createElement("h1", null, "TestMemberContainer")));
});
